<dg-password-policy #dgPasswordPolicy [policies]="policies" [control]="control">
</dg-password-policy>
